/* istanbul ignore file */

import React from 'react';
import { useMinBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import { BreakPoints } from '@constants/breakpoints';

interface IHideAtProps {
  breakpoint: BreakPoints;
  children: any;
}

export default function HideAt({
  breakpoint,
  children,
}: IHideAtProps) {
  const targetReached = useMinBreakpoint(breakpoint);
  return (
    <>
      {targetReached ? null : children}
    </>
  );
}
